import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Divider,
} from "@mui/material";
import {
  ChevronRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";

const MenuListButton = styled(ListItemButton)(({ theme }) => ({
  opacity: "0.7",
  transition: "0.3s",
  fontWeight: "400",
  margin: "5px 8px",
  borderRadius: "10px",
  color: theme.palette.primary.light,
  "& svg": {
    color: theme.palette.primary.light,
    fontSize: "22px",
  },
  "& span": {
    fontWeight: "600",
    fontSize: "15px",
  },
  "&:hover": {
    opacity: "1",
  },
  "&:active": {
    opacity: "1",
  },
  "&:focus": {
    opacity: "1",
  },
}));

const MultiLevelList = styled(List)(({ theme }) => ({
  marginLeft: "30px",
  borderLeft: `2px solid ${theme.palette.primary.dark}`,
}));

const ThirdLevelList = styled(List)(({ theme }) => ({
  marginLeft: "20px",
  borderLeft: `2px solid ${theme.palette.primary.dark}`,
}));

export default function MenuItemComponent({
  item,
  open,
  location,
  currMenuName,
  currSubMenuName,
  menuLevelOpen,
  subMenuLevelOpen,
  onMenuClick,
  onSubMenuClick,
}) {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleNavigation = (menu) => {
    navigate(`${menu.path}`);
  };

  return (
    <>
      <ListItem disablePadding sx={{ display: "block" }}>
        <Link to={item.path} style={{ textDecoration: "none" }}>
          <MenuListButton
            sx={{
              minHeight: 48,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
              background:
                location.pathname === item.path
                  ? theme.palette.secondary.main
                  : "transparent",
              opacity: location.pathname === item.path ? "1" : "0.7",
            }}
            onClick={() => onMenuClick(item.sub_menu ? item.name : "")}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 1.6 : "auto",
                justifyContent: "center",
              }}
            ></ListItemIcon>
            <ListItemText primary={item.name} sx={{ opacity: open ? 1 : 0 }} />
            {item.sub_menu ? (
              currMenuName === item.name ? (
                <KeyboardArrowDown />
              ) : (
                <KeyboardArrowUp />
              )
            ) : null}
          </MenuListButton>
        </Link>
      </ListItem>

      {item.sub_menu && currMenuName === item.name && (
        <Collapse in={menuLevelOpen} timeout="auto" unmountOnExit>
          <Divider />
          <MultiLevelList>
            {item.sub_menu.map((sub, subIndex) => (
              <React.Fragment key={`${sub.name}-${subIndex}`}>
                <ListItem disablePadding sx={{ display: "block" }}>
                  <Link to={sub.path} style={{ textDecoration: "none" }}>
                    <MenuListButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                        background:
                          location.pathname === sub.path
                            ? theme.palette.secondary.main
                            : "transparent",
                        opacity: location.pathname === sub.path ? "1" : "0.7",
                      }}
                      onClick={() =>
                        onSubMenuClick(
                          sub.children || sub.sub_menu ? sub.name : ""
                        )
                      }
                    >
                      <ListItemText
                        primary={sub.name}
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                      {(sub.children || sub.sub_menu) &&
                      (sub.children?.length > 0 || sub.sub_menu?.length > 0) ? (
                        currSubMenuName === sub.name ? (
                          <KeyboardArrowDown />
                        ) : (
                          <KeyboardArrowUp />
                        )
                      ) : (
                        <ChevronRight />
                      )}
                    </MenuListButton>
                  </Link>
                </ListItem>

                {/* Third level menu items */}
                {(sub.children || sub.sub_menu) &&
                  currSubMenuName === sub.name && (
                    <Collapse
                      in={subMenuLevelOpen}
                      timeout="auto"
                      unmountOnExit
                    >
                      <ThirdLevelList>
                        {(sub.children || sub.sub_menu)?.map(
                          (child, childIndex) => (
                            <ListItem
                              disablePadding
                              sx={{ display: "block" }}
                              key={`${child.name}-${childIndex}`}
                            >
                              <Link
                                to={child.path}
                                style={{ textDecoration: "none" }}
                              >
                                <MenuListButton
                                  sx={{
                                    minHeight: 40,
                                    justifyContent: open ? "initial" : "center",
                                    px: 2.5,
                                    background:
                                      location.pathname === child.path
                                        ? theme.palette.secondary.main
                                        : "transparent",
                                    opacity:
                                      location.pathname === child.path
                                        ? "1"
                                        : "0.7",
                                  }}
                                  onClick={() => handleNavigation(child)}
                                >
                                  <ListItemText
                                    primary={child.name}
                                    sx={{ opacity: open ? 1 : 0 }}
                                  />
                                  <ChevronRight />
                                </MenuListButton>
                              </Link>
                            </ListItem>
                          )
                        )}
                      </ThirdLevelList>
                    </Collapse>
                  )}
              </React.Fragment>
            ))}
          </MultiLevelList>
        </Collapse>
      )}
    </>
  );
}
